const Home = () => import('../pages/home').then(m => m.default || m)
const Trck = () => import('../pages/trck').then(m => m.default || m)
const processCallback = () => import('../pages/processCallback').then(m => m.default || m)

const Login = () => import('../pages/auth/login').then(m => m.default || m)
const PasswordReset = () => import('../pages/auth/password/reset').then(m => m.default || m)
const PasswordRequest = () => import('../pages/auth/password/email').then(m => m.default || m)

const Settings = () => import('../pages/settings/index').then(m => m.default || m)
const SettingsProfile = () => import('../pages/settings/profile').then(m => m.default || m)
const SettingsPassword = () => import('../pages/settings/password').then(m => m.default || m)
const SettingsSubscriptions = () => import('../pages/settings/subscriptions').then(m => m.default || m)
const SettingsFavourites = () => import('../pages/settings/favourites').then(m => m.default || m)

const SportsIndex = () => import('../pages/sports/index').then(m => m.default || m)
const SportsShow = () => import('../pages/sports/show').then(m => m.default || m)

const AlertsIndex = () => import('../pages/alerts/index').then(m => m.default || m)
const AlertsShow = () => import('../pages/alerts/show').then(m => m.default || m)

const Fantasy = () => import('../pages/fantasy/index').then(m => m.default || m)
//const GiraBola = () => import('../pages/girabola/index').then(m => m.default || m)
//const LigaNOS = () => import('../pages/liganos/index').then(m => m.default || m)
//const LaLiga = () => import('../pages/laliga/index').then(m => m.default || m)
//const EPL = () => import('../pages/epl/index').then(m => m.default || m)
const Widget = () => import('../pages/widget/index').then(m => m.default || m)
const TEC = () => import('../pages/tec/index').then(m => m.default || m)
const Results = () => import('../pages/results/index').then(m => m.default || m)
const ContestShow = () => import('../pages/results/show').then(m => m.default || m)
const Regulation = () => import('../pages/regulation/index').then(m => m.default || m)
const ContactUs = () => import('../pages/contact/index').then(m => m.default || m)

const Ligas = () => import('../pages/ligas/index').then(m => m.default || m)
const DiscontinuedIndex = () => import('../pages/discontinued/index').then(m => m.default || m)

export default [
    {path: '/', name: 'home', component: Home},
    {path: '/trck', name: 'trck', component: Trck},
    {path: '/subscription/process/:guard/:redirect', name: 'processCallback', component: processCallback},
    {path: '/subscription/process/:guard', name: 'processCallback', component: processCallback},


    {path: '/login', name: 'login', component: Login},
    {path: '/password/reset', name: 'password.request', component: PasswordRequest},
    {path: '/password/reset/:token', name: 'password.reset', component: PasswordReset},

    {
        path: '/settings', component: Settings, children: [
            {path: '', redirect: {name: 'settings.profile'}},
            {path: 'password', name: 'settings.password', component: SettingsPassword},
        ]
    },

    {path: '/profile', name: 'profile', component: SettingsProfile},
    {path: '/subscriptions', name: 'subscriptions', component: SettingsSubscriptions},
    {path: '/favourites', name: 'favourites', component: SettingsFavourites},

    {path: '/desporto/', name: 'sports.index', component: SportsIndex},
    {path: '/desporto/by/:slug', name: 'sports.source', component: SportsIndex},
    {path: '/desporto/search/:query', name: 'sports.search', component: SportsIndex},
    {path: '/desporto/:slug', name: 'sports.show', component: SportsShow},

    {path: '/ronaldo/', name: 'ronaldo.index', component: SportsIndex},
    {path: '/ronaldo/:slug', name: 'ronaldo.show', component: SportsShow},

    {path: '/alertas/', name: 'alerts.index', component: AlertsIndex},
    {path: '/alertas/:slug', name: 'alerts.show', component: AlertsShow},

    {path: '/fantasy', name: 'fantasy', component: Fantasy},
    /*
    {path: '/girabola', name: 'girabola', component: GiraBola},
    {path: '/liganos', name: 'liganos', component: LigaNOS},
    {path: '/laliga', name: 'laliga', component: LaLiga},
    {path: '/epl', name: 'epl', component: EPL},
    */

    {path: '/liga/:slug', name: 'liga.index', component: Ligas},
    {path: '/passatempos', name: 'contests', component: Results},
    {path: '/passatempos/:slug', name: 'contest.show', component: ContestShow},

    {path: '/all', name: 'widget', component: Widget},
    {path: '/pages/tec', name: 'tec', component: TEC},
    {path: '/pages/regulation', name: 'regulation', component: Regulation},
    {path: '/pages/contact', name: 'contact-us', component: ContactUs},

    {path: '*', name: '404', component: require('../pages/errors/404.vue')},

    { path: '/discontinued', name: 'Discontinued', component: DiscontinuedIndex },
]



// WEBPACK FOOTER //
// ./resources/assets/js/router/routes.js